/* 封装axios用于发送请求 */
import axios from 'axios'
// withCredentials设置为true，在axios发送请求时会携带Cookie
axios.defaults.withCredentials = true
// 创建一个新的axios实例
const request = axios.create({
  // 请求的基地址
  baseURL: '',
  // 请求的超时时间
  timeout: 5000
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  return response.data
}, function (error) {
  console.error('[API Error]', error.config?.url, error.message)
  return Promise.reject(error)
})

export default request
